import React, { useEffect, useRef, useState } from "react";
import "./Dashboard.css";
import DateRangePicker from "./DateRangePicker";
import { getDetails, getStatus } from "../../services/api/dashboard";
import { CircularProgress, Skeleton } from "@mui/material";
import Topbar from "../Global/topbar";
import CachedIcon from "@mui/icons-material/Cached";
import { TextField, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

{
  /* <div className="card red">
          <div className="icon">💳</div>
          <h2>Today's Recharges</h2>
          <p>320</p>
        </div> */
}

const Dashboard = () => {
  const [reportData, setReportData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [start_date, setStart] = useState("");
  const [end_date, setEnd] = useState("");
  const start_key = useRef({ 1: null });
  const [total, setTotal] = useState(0);
  const totalPages = Math.ceil(total / rowsPerPage);
  const handleRowsChange = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };
  const [start_d, setStart_d] = useState("");
  const [end_d, setEnd_d] = useState("");
  const [status, setStatus] = useState([]);
  const [search, setSearch] = useState("");
  const fetchData = () => {
    setReportData([]);
    try {
      const paginationKey = start_key.current[parseInt(currentPage)];
      getDetails(rowsPerPage, paginationKey, start_date, end_date, search)
        .then((response) => {
          const data =
            response?.data?.data?.Items.length > 0
              ? response?.data?.data?.Items
              : undefined;
          setReportData(data);
          start_key.current[currentPage + 1] =
            response?.data?.data.LastEvaluatedKey || null;
          setTotal(response?.data?.data.total);
        })
        .catch((error) => {
          console.log(error);
          setReportData(undefined);
        });
    } catch (error) {
      console.log(error);
      setReportData(undefined);
    }
  };

  const statusData = () => {
    try {
      getStatus(start_d, end_d)
        .then((response) => {
          setStatus(response?.data?.data || []);
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (end_d) {
      setStatus([]);
      statusData();
    }
  }, [start_d]);

  useEffect(() => {
    statusData();
  }, [end_d]);

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchData();
    }, 200);
    return () => clearTimeout(handler);
  }, [rowsPerPage, start_key, end_date, currentPage, search]);

  useEffect(() => {
    if (end_date) {
      setReportData([]);
      fetchData();
    }
  }, [start_date]);
  const datakey = [
    { key: "created_at", type: "date" },
    { key: "created_at", type: "time" },
    { key: "user.name" },
    { key: "user.email"},
    { key: "user.role"},
    { key: "transaction_for" },
    {
      key: "amount",
      format: (v, row) => {
        if (row.transaction_type === "deducted") {
          return <span style={{ color: "red" }}>-₹{v}</span>;
        }
        if (row.transaction_type === "added") {
          return <span style={{ color: "green" }}>+₹{v}</span>;
        }
        return `₹${v}`;
      },
    },
  ];

  const today = new Date().toISOString().split("T")[0];

  const formatAmount = (amount) => {
    if (amount >= 1000000000000) {
      return (amount / 1000000000000).toFixed(1).replace(/\.0$/, "") + "Kharab";
    } else if (amount >= 10000000000) {
      return (amount / 10000000000).toFixed(1).replace(/\.0$/, "") + "Arab";
    } else if (amount >= 10000000) {
      return (amount / 10000000).toFixed(1).replace(/\.0$/, "") + "Cr";
    } else if (amount >= 100000) {
      return (amount / 100000).toFixed(1).replace(/\.0$/, "") + "L";
    } else if (amount >= 1000) {
      return (amount / 1000).toFixed(1).replace(/\.0$/, "") + "K";
    }
    return amount.toString();
  };

  const cards = [
    {
      color: "blue",
      icon: "📞",
      title: "Total Calls",
      value: status?.call_log
        ? status?.call_log == 0
          ? "0"
          : status.call_log
        : "0",
    },
    {
      color: "purple",
      icon: "💰",
      title: "Recharge Amounts",
      value: status?.recharges_amount
        ? `₹${formatAmount(status?.recharges_amount)}`
        : "₹0",
    },
    {
      color: "teal",
      icon: "👥",
      title: "Total Users",
      value: status?.user
        ? status.user === 0
          ? "0"
          : formatAmount(status.user)
        : "0",
    },
    {
      color: "green",
      icon: "🧑‍💼",
      title: "Consultants",
      value: status?.consultant
        ? status?.consultant === 0
          ? "0"
          : formatAmount(status.consultant)
        : "0",
    },
    {
      color: "red",
      icon: "📞💵",
      title: "Total Call Price",
      value: status?.call_spends
        ? `₹${formatAmount(status?.call_spends)}`
        : "₹0",
    },
    {
      color: "pink",
      icon: "💬💵",
      title: "Total Chat Price",
      value: status?.chat_spends
        ? `₹${formatAmount(status?.chat_spends)}`
        : "₹0",
    },
  ];

  return (
    <>
      <Topbar />
      <div className="dashboard">
        <header className="header">
          <h1 className="logo">My Dashboard</h1>
          <div className="header-right">
            {/* <button className="icon-btn">🔔</button>
          <div className="profile">👤</div> */}
          </div>
        </header>

        <div className="drp-container">
          <span>
            <div className="drp-input-wrapper">
              {!start_d && <span className="drp-placeholder">Start Date</span>}
              <input
                type="date"
                value={start_d}
                max={today}
                style={{
                  cursor: "pointer",
                }}
                onChange={(e) => {
                  setStart_d(e.target.value);
                  if (end_d && e.target.value > end_d) setEnd_d(today);
                }}
                className="drp-input"
              />
            </div>

            <div className="drp-input-wrapper">
              {!end_d && <span className="drp-placeholder">End Date</span>}
              <input
                type="date"
                value={end_d}
                min={start_d || undefined}
                max={today}
                disabled={!start_d}
                style={{
                  cursor: start_d ? "pointer" : "not-allowed",
                }}
                onChange={(e) => {
                  setEnd_d(e.target.value);
                  setStatus([]);
                }}
                className="drp-input"
              />
            </div>
          </span>
          <div
            className="drp-reset"
            onClick={() => {
              setStart_d("");
              setEnd_d("");
              setStatus([]);
              statusData();
            }}
          >
            Total &nbsp;&nbsp;
            <CachedIcon />
          </div>
        </div>
        <div className="stats">
          {cards.map((card, index) => (
            <div
              key={index}
              className={`card`}
              style={{
                borderTop: "4px solid var(--admin-page-color) ",
              }}
            >
              <div className="icon">{card.icon}</div>
              <div className="sub-box">
                <h2>{card.title}</h2>
                <p>
                  {card?.value || (
                    <Skeleton
                      animation="wave"
                      style={{
                        width: "50px",
                      }}
                    />
                  )}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="report">
          <div id="top-text">
            <span>
              <h2>Transactions Report</h2>
            </span>
            <span id="search_date">
              <DateRangePicker
                setStart={setStart}
                start={start_date}
                setEnd={setEnd}
                end={end_date}
              />
              <TextField
                value={search}
                onChange={(e) =>{
                  setSearch(e.target.value)
                  start_key.current = { 1: null }
                  setCurrentPage(1)
                }}
                placeholder="Search..."
                variant="outlined"
                id="input-tag"
                size="small"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "11px",
                    "&.Mui-focused fieldset": {
                      borderColor: "#1c1c1c58",
                      borderWidth: "2px",
                    },
                  },
                }}
              />
            </span>
          </div>
          <table>
            <thead>
              <tr>
                <th>Date</th>
                <th>Time</th>
                <th>User</th>
                <th>Email</th>
                <th>Role</th>
                <th>Transaction For</th>
                <th>Amount</th>
              </tr>
            </thead>
            {(reportData === undefined ? [] : reportData.length) > 0 && (
              <tbody>
                {(reportData ?? []).map((row, index) => (
                  <tr key={index}>
                    {datakey.map((key, i) => {
                      let value = key.key
                        .split(".")
                        .reduce((obj, k) => obj?.[k], row);

                      if (value === null || value === undefined) {
                        value = "NA";
                      } else if (key.type === "date" && value) {
                        value = new Date(value).toISOString().split("T")[0]; // 2025-08-07
                      } else if (key.type === "time" && value) {
                        value = new Date(value).toLocaleTimeString("en-US", {
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: true,
                        });
                      } else if (typeof key.format === "function") {
                        value = key.format(value, row);
                      }

                      return <td key={i}>{value}</td>;
                    })}
                  </tr>
                ))}
              </tbody>
            )}
            {reportData === undefined ? (
              <tbody>
                <tr>
                  <td
                    colSpan={7}
                    style={{
                      height: "300px",
                      textAlign: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "100%",
                        width: "100%",
                      }}
                    >
                      <h2>Data Not Found</h2>
                    </div>
                  </td>
                </tr>
              </tbody>
            ) : (
              reportData.length === 0 && (
                <tbody>
                  <tr>
                    <td
                      colSpan={7}
                      style={{
                        height: "300px",
                        textAlign: "center",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          height: "100%",
                          width: "100%",
                        }}
                      >
                        <CircularProgress />
                      </div>
                    </td>
                  </tr>
                </tbody>
              )
            )}
          </table>
          <div className="pagination-data">
            <button
              onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
              disabled={currentPage === 1}
            >
              Prev
            </button>
            <span>
              Page {currentPage} of {totalPages}
            </span>
            <button
              onClick={() => {
                setCurrentPage((p) => Math.min(p + 1, totalPages));
              }}
              disabled={
                !(total > rowsPerPage) ||
                (!reportData==undefined && reportData.length === 0 )||
                currentPage === totalPages
              }
              // disabled={start_key.current ? false : true}
            >
              Next
            </button>

            <label>
              Rows per page:{" "}
              <select value={rowsPerPage} onChange={handleRowsChange}>
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={15}>15</option>
                <option value={20}>20</option>
              </select>
            </label>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
